import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const dashboardSurfaceAppBuilder = DataRouterApplicationBuilder.create('dashboard-surface')
